import { Flex, SxProps, Text } from '@modusign/design-system';
import { ReactNode, useMemo } from 'react';

const fontSizeMap = {
  small: 'xxs',
  medium: 'xs',
  large: 'sm',
};

interface BadgeProps extends SxProps {
  size?: 'small' | 'medium' | 'large';
  round?: 'full' | 'semi';
  variant?: 'basic' | 'danger' | 'emphasis';
  fontWeight?: 'light' | 'regular' | 'medium' | 'bold';
  style?: React.CSSProperties;
  children: ReactNode;
}

const bgColor = {
  basic: 'statusBackgroundNeutralBase',
  danger: 'statusNegativeDark',
  emphasis: 'statusBackgroundEmphasisUltraLight',
};

const color = {
  basic: 'textNeutralSlightlyLight',
  danger: 'white',
  emphasis: 'textEmphasisBase',
};

function Badge({
  children,
  round = 'full',
  size = 'medium',
  fontWeight = 'medium',
  style,
  sx,
  variant = 'basic',
}: BadgeProps) {
  const paddingX = useMemo(() => {
    if (round === 'semi') return 2;
    return size === 'small' ? 2 : 3;
  }, [round, size]);

  return (
    <Flex
      alignItems="center"
      bg={bgColor[variant]}
      borderRadius={round === 'full' ? '10px' : '3px'}
      color={color[variant]}
      display="inline-flex"
      minWidth="max-content"
      ml="2px"
      px={paddingX}
      py="2px"
      style={style}
      sx={sx}
      textAlign="center"
    >
      <Text fontSize={fontSizeMap[size]} fontWeight={fontWeight}>
        {children}
      </Text>
    </Flex>
  );
}

export default Badge;
